import { BaseException, BaseExceptionContext } from './base.exception';

interface NotFoundExceptionContext extends BaseExceptionContext {}

export class NotFoundException extends BaseException {
  constructor(
    entity: string,
    query: string,
    context: NotFoundExceptionContext,
  ) {
    super(`${entity} not found for query "${query}"`, context);
  }
}
